import React, { useState } from 'react';
import { Card, Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from '../common/FalconCardHeader';

const NotificationDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown nav inNavbar isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
      <DropdownToggle nav className="px-0">
        <FontAwesomeIcon icon="bell" transform="shrink-6" className="fs-4" />
      </DropdownToggle>
      <DropdownMenu right className="dropdown-menu-card">
        <Card className="card-notification shadow-none" style={{ maxWidth: '20rem' }}>
          <FalconCardHeader className="card-header" title="Bildirishnomalar" titleTag="h6" light={false} />
          <div className="p-4 text-center text-500">
            Hozircha yangi tizim bildirishnomalari mavjud emas.
          </div>
        </Card>
      </DropdownMenu>
    </Dropdown>
  );
};

export default NotificationDropdown;
